import configureStore from './configureStore';

// You can make configurations for the initial or preloaded state here and
// provide it to configureStore
const initialState = undefined;

export default configureStore(initialState);